import { jsx as _jsx } from "react/jsx-runtime";
import { motion, useSpring } from 'motion/react';
import { useRef } from 'react';
import styled from 'styled-components';
import { useBorderBoxSizeCallback } from '../../lib/react';
export const AnimateHeight = ({ className, children, }) => {
    const ref = useRef(null);
    const heightMotionValue = useSpring(0.0001, { duration: 300, bounce: 0 });
    useBorderBoxSizeCallback(ref, (size) => {
        if (heightMotionValue.get() === 0.0001) {
            heightMotionValue.jump(size.blockSize);
            return;
        }
        heightMotionValue.set(size.blockSize);
    });
    return (_jsx(Root, { style: { height: heightMotionValue }, className: className, children: _jsx(Measurer, { ref: ref, children: children }) }));
};
const Root = styled(motion.div) `
  position: relative;
  overflow: hidden;
`;
const Measurer = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
`;
//# sourceMappingURL=animate-height.js.map